module.exports = __webpack_public_path__ + "img/corn-juice.92c0075d.jpg";